import { registerLocaleData } from '@angular/common';
import localeES from '@angular/common/locales/es';
import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

registerLocaleData(localeES);

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
